// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://vh6ccsxcenbmfk7dtcotlzyuvq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "us-east-1:e6b3d839-9b02-44e9-b268-e8b9cdbf13e6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_zwXHscm6p",
    "aws_user_pools_web_client_id": "7h52fgk4isk5p019srho6i8e28",
    "oauth": {}
};


export default awsmobile;
